    <app-matspinner *ngIf="isLoading"></app-matspinner>

    <mat-card-header>
        <mat-card-title class="title">Add Store</mat-card-title>
      </mat-card-header>

      <mat-divider  class="divider"></mat-divider>

        <div class="container">
            <form [formGroup]="form">
                <br>
                <div class="row"  style="text-align: left; margin-top: 2%; margin-left: 3%; font-size: 17px;">
                    <mat-label >Use ENTER key to add additional Pharmacy NCPDP IDs</mat-label>
                </div>
              <div class="row" style="margin-top: 2.5%; margin-left: 3%; margin-right: 3%;">
                <div class="col-md-12">
                <mat-form-field class="textarea-width" appearance="outline">
                    <mat-label style="font-size: 17px;">NCPDP ID</mat-label>
                    <textarea formControlName="NCPDPID" matInput placeholder="NCPDP ID" cdkTextareaAutosize="22px" cdkAutosizeMinRows="17"
                    cdkAutosizeMaxRows="10" required (keyup)="clearDuplicateValidation();"></textarea>
                    <mat-error>{{errorMessageForPharmacyNcpdpid}}</mat-error>
                  </mat-form-field>
                </div>
            </div>
            <div class="row" style="margin-top: 3%; margin-right: -4%;">
                <div class="col-md-12" style="text-align: center;">
                    <button mat-raised-button style="" [disabled]="!this.form.valid" 
                        (click)="submitForm()" class="btn-save">Save</button>
                    <button mat-raised-button style="" mat-dialog-close 
                        class="btn-cancel">Cancel</button>
                </div>
            </div>
           
            </form>
        </div>
  

